import React from 'react';
import { XCircle, Loader2 } from 'lucide-react';
import { Scrape } from '@/helpers/scrapeDatabase';

interface PricingUrlModalProps {
  isOpen: boolean;
  scrape: Scrape | null;
  editingUrl: string;
  isUpdating: boolean;
  onClose: () => void;
  onSave: () => void;
  onUrlChange: (url: string) => void;
}

export const PricingUrlModal: React.FC<PricingUrlModalProps> = ({
  isOpen,
  scrape,
  editingUrl,
  isUpdating,
  onClose,
  onSave,
  onUrlChange,
}) => {
  if (!isOpen || !scrape) return null;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Edit Pricing Page URL</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XCircle className="h-5 w-5" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Company: {scrape.slug}
            </label>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Current URL: {scrape.url}
            </label>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Pricing Page URL
            </label>
            <input
              type="text"
              value={editingUrl}
              onChange={(e) => onUrlChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="https://example.com/pricing"
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>
          
          <div className="flex justify-end gap-2 pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={isUpdating}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-md transition-colors flex items-center gap-2"
            >
              {isUpdating ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  Saving...
                </>
              ) : (
                'Save'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
